module.exports = __webpack_public_path__ + "img/fire.14882385.jpg";